var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLinkedInsvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 50 50",
    width: "50pt",
    height: "50pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_RjvbfYyckFvfiyG6QDqwUBR08tgHw98w"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_RjvbfYyckFvfiyG6QDqwUBR08tgHw98w)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 40 0 L 10 0 C 4.484 0 0 4.484 0 10 L 0 40 C 0 45.516 4.484 50 10 50 L 40 50 C 45.516 50 50 45.516 50 40 L 50 10 C 50 4.484 45.516 0 40 0 Z  M 16 34.898 L 16 42 L 8 42 L 8 19 L 16 19 L 16 34.898 Z  M 12 16.5 C 9.602 16.5 8 14.8 8 12.7 C 8 10.601 9.602 9 12 9 C 14.398 9 15.898 10.602 16 12.7 C 16 14.8 14.5 16.5 12 16.5 Z  M 42 42 L 34 42 L 34 29 C 34 28.102 33.898 25 30.5 25 C 27.5 25 27 27.898 27 29 L 27 42 L 19 42 L 19 19 L 27 19 L 27 22.102 C 27 22.102 28.602 19 33.3 19 C 38.102 19 42 22.3 42 29 L 42 42 Z ",
    fill: "rgb(255,255,255)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedInsvg);
export default __webpack_public_path__ + "static/media/IconLinkedInsvg.2c60d3125e907d076b2dd54c9fd258bf.svg";
export { ForwardRef as ReactComponent };